import { TPromotionCategories } from '@/shared/types/deprecated-types'
import { RadioOption } from '@/shared/types/radio-option'

export const promotionCategoriesAdapter = (categoriesList: TPromotionCategories): RadioOption[] =>
	categoriesList.map(({ CATEGORY_NAME, CATEGORY_CODE }) => ({
		value: CATEGORY_CODE,
		label: CATEGORY_NAME
	}))
